<div class="relative" #container>
  <div class="notification-container">
    <button
      type="button"
      class="notificacion-boton focus:outline-none"
      (click)="toggle()"
      aria-label="Abrir notificaciones"
    >
      <img
        [src]="
          hasUnread
            ? 'assets/img/icon-notification-on.svg'
            : 'assets/img/icon-notification.svg'
        "
        alt="Notificación"
        class="cursor-pointer"
      />
    </button>
  </div>

  <div
    *ngIf="isOpen"
    class="absolute right-0 mt-6 w-[420px] rounded-lg bg-white shadow-sm z-50"
  >
    <div class="px-5 py-4 border-b border-gray-100">
      <p class="text-xl font-bold text-texto-titulos">Notificaciones</p>
    </div>

    <div class="max-h-96 overflow-auto">
      <div class="px-5 pt-3 pb-2">
        <p class="text-base font-semibold text-texto-titulos">Este día</p>
      </div>

      <ul class="px-3 pb-3 space-y-3">
        <li
          *ngFor="let n of notifications"
          (click)="onNotificationClick(n)"
          class="rounded-lg border border-neutrales-100 bg-white hover:bg-neutrales-50 transition py-3 cursor-pointer"
        >
          <div class="flex items-start gap-3 p-3 bg-secundario-50">
            <span
              class="mt-1 inline-block h-2.5 w-2.5 rounded-full"
              [ngClass]="{ 'bg-secundario-base': !n.data.isRead }"
            ></span>

            <div class="flex-1">
              <div class="flex items-center justify-between">
                <p class="text-sm font-bold text-texto-titulos">
                  {{ n.data.title }}
                </p>
                <span
                  class="text-[11px] text-texto-titulos font-bold whitespace-nowrap"
                >
                  {{ formatTime(n.data.timestamp) }}
                </span>
              </div>
              <p
                class="mt-1 text-xs leading-5 text-texto-titulos"
                [innerHTML]="formatNotificationBody(n.data.body)"
              ></p>
            </div>
          </div>
        </li>

        <li *ngIf="!notifications?.length" class="px-3 py-8 text-center">
          <p class="text-sm text-gray-500">No hay notificaciones.</p>
        </li>
      </ul>
    </div>
  </div>
</div>
